module.exports = __webpack_public_path__ + "img/joints_video_splash.cdde94e3.jpg";